import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchByTerm'
})
export class SearchByTermPipe implements PipeTransform {

  /**
   * Search in an array with an array of object keys
   * @param {any[]} array
   * @param {string} term
   * @param {string[]} fields
   * @returns {any[]}
   */
  transform(array: any[], term: string, fields: string[]): any[] {
    if (!term || !fields || fields.length === 0) {
      return array;
    }
    let results = [];
    fields.forEach(field => {
      // if field is a list
      if (field.includes('.')) {
        var fieldList = field.split('.')[0];
        var fieldValue = field.split('.')[1];
      };

      results = results.concat(array.filter((value: any) => {
        if (fieldList && fieldValue) {
          // search in list
          return value[fieldList].filter((listElement: any) => {
            return listElement[fieldValue].toString().toLowerCase().indexOf(term.toLowerCase()) > -1;
          }).length > 0;
        }
        else if (!value[field]) {
          return false;
        }
        return value[field].toString().toLowerCase().indexOf(term.toLowerCase()) > -1;
      }));
    });
    // Return unique results
    return results.filter((v, i, a) => a.indexOf(v) === i);
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/search-by-term.pipe.ts